// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const DotNetIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 48 46">
    <path d="M40.18 24.13q0-.12-.07-.18t-.26-.06h-.17v.48h.2q.3 0 .3-.24m.27 1h-.24l-.15-.34q-.12-.26-.25-.26h-.13v.6h-.2v-1.4h.4q.25 0 .4.1.1.11.1.27 0 .15-.09.25a.5.5 0 0 1-.26.14q.12.02.23.26zm.44-.7q0-.4-.29-.69a1 1 0 0 0-.69-.28.94.94 0 0 0-.97.98q0 .42.28.7t.7.27.68-.28a1 1 0 0 0 .29-.7m.13 0q0 .46-.32.78-.32.31-.8.31-.46 0-.78-.3-.3-.3-.31-.78 0-.46.32-.78.3-.32.79-.32.45 0 .77.3.33.31.33.79M11.03 28.34h-.68v-3.89q0-.46.05-1.12h-.01q-.1.39-.18.56l-1.97 4.45H7.9l-1.99-4.42a3 3 0 0 1-.17-.6h-.01q.03.36.03 1.14v3.88H5.1v-5.8h.9l1.78 4.05q.2.45.26.7h.03q.17-.48.28-.72l1.81-4.02h.86zM13.12 28.34h-.66V24.2h.66zm.11-5.62q0 .18-.13.3a.4.4 0 0 1-.3.13.4.4 0 0 1-.3-.12.4.4 0 0 1-.13-.31q0-.18.12-.3a.4.4 0 0 1 .3-.13q.2 0 .31.13a.4.4 0 0 1 .13.3M17.25 28.15q-.48.3-1.14.3-.89 0-1.43-.6a2 2 0 0 1-.54-1.48q0-1 .59-1.64.58-.63 1.57-.63.54 0 .96.21V25q-.46-.32-.99-.32-.63 0-1.03.44-.42.45-.42 1.2 0 .73.39 1.15.38.42 1.02.42.54 0 1.02-.36zM20.41 24.87a1 1 0 0 0-.5-.13q-.4 0-.68.36-.32.41-.32 1.13v2.11h-.66V24.2h.66v.86h.02q.15-.46.45-.7a1 1 0 0 1 .63-.23q.27 0 .4.06zM24.1 26.28q0-.8-.36-1.21-.34-.4-.97-.4-.61 0-1 .4-.38.44-.38 1.23 0 .74.37 1.16.38.42 1 .42.66 0 1-.43.34-.4.34-1.17m.68-.02q0 1-.56 1.58-.56.6-1.5.6a2 2 0 0 1-1.48-.6q-.53-.57-.53-1.52 0-1.08.6-1.67.57-.55 1.5-.55t1.45.58.52 1.58M28.07 27.24q0 .5-.38.84-.42.36-1.14.36-.59 0-1.02-.25v-.7q.48.38 1.07.39.8 0 .79-.58 0-.24-.18-.4-.17-.15-.67-.38-.53-.22-.74-.47-.27-.3-.27-.75 0-.52.41-.85.4-.35 1.05-.35.5 0 .89.2v.66q-.41-.3-.94-.3-.33 0-.53.17-.2.16-.2.42 0 .27.17.42.14.14.62.35.52.22.76.46.3.3.3.76M32.12 26.28q0-.8-.36-1.21-.35-.4-.98-.4-.6 0-.99.4-.39.44-.39 1.23 0 .74.38 1.16.37.42 1 .42.66 0 1-.43.34-.4.34-1.17m.68-.02q0 1-.56 1.58-.55.6-1.5.6a2 2 0 0 1-1.48-.6q-.54-.57-.54-1.52 0-1.08.6-1.67.57-.55 1.51-.55.93 0 1.45.58.52.57.52 1.58M35.72 22.8a1 1 0 0 0-.44-.11q-.7 0-.7.88v.63h.97v.56h-.97v3.58h-.66v-3.58h-.7v-.56h.7v-.67q0-.68.42-1.07.37-.33.9-.33.3 0 .48.07zM38.33 28.3q-.23.14-.62.14-1.08 0-1.08-1.23v-2.44h-.71v-.57h.7v-1l.67-.22v1.22h1.04v.57H37.3v2.33q0 .42.14.6t.47.17a.7.7 0 0 0 .43-.13zM2.52 44.5q0 .48-.35.84-.36.36-.85.35-.49 0-.83-.35a1.2 1.2 0 0 1-.34-.84q0-.5.34-.85t.83-.35q.5 0 .85.35.35.36.35.85M17.35 45.45H15.2L7.35 33.34q-.29-.44-.48-.96h-.06q.08.49.08 2.1v10.97H5.11v-15.2h2.31l7.61 11.93q.45.7.62 1.01h.04q-.1-.65-.11-2.23v-10.7h1.77zM28.77 45.45H20.7v-15.2h7.71v1.61h-5.93v5.06H28v1.61h-5.5v5.31h6.28zM40.99 31.86H36.6v13.6h-1.78v-13.6h-4.39v-1.6H41z" />
    <path
      fill="url(#dot-net_svga)"
      d="M16.75 4c1.71 5.26 2.37 14.63 7.39 14.63q.57 0 1.16-.1c-4.57-1.07-5.11-10.35-7.9-15.15z"
    />
    <path
      fill="url(#dot-net_svgb)"
      d="M17.4 3.38c2.79 4.8 3.33 14.08 7.9 15.14q.54-.1 1.08-.29c-4.1-2-5.24-11.01-8.4-15.35z"
    />
    <path
      fill="#14559A"
      d="M21.42.53q-.58 0-1.16.1-1.53.3-3.1 1.3.44.42.82.95A11 11 0 0 1 21.14.96q.58-.21 1.18-.32a4 4 0 0 0-.9-.11"
    />
    <path
      fill="url(#dot-net_svgc)"
      d="M29.58 16.38q.63-.5 1.26-1.1C29.09 10.03 28.47.53 23.4.53q-.55 0-1.1.1c4.61 1.14 5.2 11.17 7.27 15.74"
    />
    <path fill="#3092C4" d="M22.31.64a4 4 0 0 0-.9-.11h2q-.55 0-1.1.1" />
    <path
      fill="#1969BC"
      d="M29.49 17.49a8 8 0 0 1-.57-.62q-1.28.9-2.54 1.36a4 4 0 0 0 1.75.4c.95 0 1.7-.1 2.33-.41a4 4 0 0 1-.97-.73"
    />
    <path
      fill="url(#dot-net_svgd)"
      d="M21.14.96c4.13 2.16 4.48 11.94 7.78 15.91q.33-.23.66-.5C27.5 11.82 26.92 1.79 22.32.65q-.6.1-1.18.32"
    />
    <path
      fill="url(#dot-net_svge)"
      d="M17.98 2.88c3.16 4.34 4.3 13.34 8.4 15.35q1.26-.45 2.54-1.36c-3.3-3.97-3.65-13.75-7.78-15.9q-1.57.58-3.16 1.91"
    />
    <path
      fill="url(#dot-net_svgf)"
      d="M14.72 3.88c-.5 1.12-1 2.6-1.61 4.52A34 34 0 0 1 16.75 4a13 13 0 0 0-.54-1.4q-.75.56-1.49 1.28"
    />
    <path
      fill="#2B74B1"
      d="M16.65 2.28q-.23.15-.44.32.3.64.54 1.4l.65-.62q-.35-.6-.75-1.1"
    />
    <path
      fill="#125A9E"
      d="m17.17 1.93-.52.35q.4.5.75 1.1l.58-.5a8 8 0 0 0-.81-.95"
    />
    <path
      fill="url(#dot-net_svgg)"
      d="M45.33.13c-2.34 9-7.21 16.23-11.3 18.06h-.01l-.22.1h-.03l-.06.03h-.03l-.1.04-.04.02-.05.02-.05.01-.05.02-.08.02-.04.01-.06.02-.04.01-.06.02-.08.01q.27.1.58.1c3.88 0 7.79-6.94 14.26-18.5z"
    />
    <path
      fill="url(#dot-net_svgh)"
      d="m12.26.9.01-.01h.01l.07-.03h.01l.02-.02.06-.02.16-.05h.02l.06-.03h.03l.06-.03h.03l.21-.06h.03l.06-.02h.03L13.2.6h.01l.13-.02h.03l.06-.01h.03l.06-.02h.03l.14-.02-.41-.02C8.9.52 2.9 8.62.18 19.12h.53Q2 16.8 3.07 14.73C4.97 7.3 8.83 2.23 12.27.9"
    />
    <path
      fill="#0D82CA"
      d="M14.72 3.88q.75-.71 1.49-1.28a7 7 0 0 0-.36-.68 8 8 0 0 0-1.13 1.96M15.08.95q.42.36.77.97l.23-.26a4 4 0 0 0-1-.7"
    />
    <path
      fill="url(#dot-net_svgi)"
      d="M3.07 14.73C7.05 7.06 8.93 2.21 12.27.9c-3.44 1.35-7.3 6.41-9.2 13.84"
    />
    <path
      fill="#127BCA"
      d="m16.08 1.66-.23.26q.19.3.36.68l.44-.32a6 6 0 0 0-.57-.62"
    />
    <path
      fill="url(#dot-net_svgj)"
      d="m4.87 19.08-.07.01h-.08l-.15.02h-.02c4.03-.12 5.88-2.13 6.79-5.06q1.04-3.32 1.77-5.65A80 80 0 0 0 8 16.78a4.2 4.2 0 0 1-3.14 2.3"
    />
    <path
      fill="url(#dot-net_svgk)"
      d="M4.87 19.08a4.2 4.2 0 0 0 3.15-2.3c1.7-3.17 3.4-6 5.08-8.38.62-1.93 1.12-3.4 1.62-4.52-3.36 3.2-6.73 8.51-9.85 15.2"
    />
    <path
      fill="#05A1E6"
      d="M3.07 14.73A152 152 0 0 1 .7 19.12h1.52q.3-2.31.84-4.38"
    />
    <path
      fill="url(#dot-net_svgl)"
      d="M13.55.56h-.03l-.06.02h-.03l-.06.01h-.03q-.07.02-.13.03h-.01l-.07.01-.03.01-.06.01-.03.01-.21.06h-.03l-.06.02-.03.01-.06.02h-.03l-.14.06-.07.02-.03.01-.06.03h-.02c-3.33 1.32-5.22 6.18-9.2 13.85a37 37 0 0 0-.84 4.38h2.34l.15-.02h.09l.07-.01c3.11-6.69 6.48-12 9.84-15.2q.55-1.25 1.14-1.96-.36-.6-.78-.97l-.05-.03-.05-.02-.04-.02-.06-.03-.04-.01-.09-.04-.04-.01-.06-.03-.04-.01-.09-.03L14.4.7l-.03-.01-.09-.03h-.02L14.05.6h-.02l-.1-.02h-.02l-.1-.02h-.03L13.7.56z"
    />
    <path
      fill="url(#dot-net_svgm)"
      d="M36.2 5.11c-.76 2.46-1.38 4.48-1.92 6.15A67 67 0 0 0 40.42.53c-2.3.72-3.52 2.37-4.21 4.58"
    />
    <path
      fill="url(#dot-net_svgn)"
      d="m34.35 18.03-.32.16c4.09-1.83 8.96-9.06 11.3-18.06h-.48c-5.36 9.58-7.09 16-10.5 17.9"
    />
    <path
      fill="#079AE1"
      d="M31.68 17.23c.89-1.09 1.61-2.93 2.6-5.97a30 30 0 0 1-3.44 4v.02q.37 1.13.84 1.95"
    />
    <path
      fill="#1969BC"
      d="M31.68 17.23a4 4 0 0 1-1.22.99 3.5 3.5 0 0 0 1.45.4h.01l.1.01h.48l.08-.02h.03l.09-.02h.02l.1-.01h.01l.2-.04q-.79-.31-1.35-1.3"
    />
    <path fill="#1E5CB3" d="M24.14 18.63a6 6 0 0 0 2.24-.4 4 4 0 0 0 1.75.4z" />
    <path
      fill="#1E5CB3"
      d="M28.13 18.63c.95 0 1.7-.1 2.33-.41a3.4 3.4 0 0 0 1.45.4h.01l.1.01h.12z"
    />
    <path
      fill="#1D60B5"
      d="M32.14 18.63h.37l.07-.02h.03l.09-.02h.03l.1-.02.2-.04q.28.1.58.1l-1.47.01"
    />
    <path
      fill="#175FAB"
      d="M30.84 15.28a18 18 0 0 1-1.92 1.6q.27.32.57.61.45.45.97.73l.24-.13q.54-.32.98-.86-.47-.82-.84-1.95"
    />
    <path
      fill="url(#dot-net_svgo)"
      d="M43.36.13h-2.38q-.2 0-.38.02l-.18.37a67 67 0 0 1-6.14 10.73c-.99 3.04-1.71 4.89-2.6 5.97q.56.99 1.34 1.3h.05l.03-.01.07-.02.04-.01.06-.02h.03l.1-.03.04-.02q.02 0 .04-.02l.06-.01.04-.02.1-.03.03-.01.06-.03h.03l.22-.1.33-.16c3.41-1.9 5.14-8.32 10.5-17.9z"
    />
    <path
      fill="#7DCBEC"
      d="M13.69.55h.02l.07.01h.02l.11.02h.02l.1.02h.02l.22.05h.02l.09.03.02.01.12.04.09.03.03.01.07.03.04.01.08.04.05.02.05.02.05.02.04.02q.57.3 1.06.74.18-.18.37-.34A4 4 0 0 0 13.7.56"
    />
    <path
      fill="#5EC5ED"
      d="M16.08 1.66q.3.29.57.62l.52-.35a6 6 0 0 0-.72-.6q-.2.14-.37.33"
    />
    <path
      fill="url(#dot-net_svgp)"
      d="m13.69.55.32-.01q1.39.02 2.44.78c.75-.59 1.66-.8 2.91-.8h-6.08q.2 0 .41.03"
    />
    <path
      fill="url(#dot-net_svgq)"
      d="M19.36.53c-1.25 0-2.16.2-2.9.8q.37.26.7.6a9 9 0 0 1 3.1-1.3q.58-.1 1.16-.1z"
    />
    <path
      fill="url(#dot-net_svgr)"
      d="M34.28 11.26q.8-2.49 1.93-6.15c.7-2.2 1.92-3.86 4.21-4.58l.18-.38c-3.75.23-5.5 2.13-6.38 4.96-1.54 4.93-2.48 8.12-3.38 10.16a30 30 0 0 0 3.44-4.01"
    />
    <path d="M39.78 17.32h-.42v1.32h-.18v-1.32h-.42v-.16h1.02zM41.52 18.64h-.17v-1l.01-.28-.04.14-.5 1.14h-.1l-.5-1.13-.04-.15v1.28h-.16v-1.48h.22l.46 1.03.06.18h.01l.07-.18.46-1.03h.22z" />
    <defs>
      <linearGradient
        id="dot-net_svga"
        x1={444.29}
        x2={444.29}
        y1={-294.24}
        y2={1980.21}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0994DC" />
        <stop offset={0.35} stopColor="#66CEF5" />
        <stop offset={0.85} stopColor="#127BCA" />
        <stop offset={1} stopColor="#127BCA" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgb"
        x1={466.18}
        x2={466.18}
        y1={-302.33}
        y2={2030.08}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0E76BC" />
        <stop offset={0.36} stopColor="#36AEE8" />
        <stop offset={0.85} stopColor="#00ADEF" />
        <stop offset={1} stopColor="#00ADEF" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgc"
        x1={448.42}
        x2={448.42}
        y1={1757.95}
        y2={-97.92}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1C63B7" />
        <stop offset={0.5} stopColor="#33BDF2" />
        <stop offset={1} stopColor="#33BDF2" stopOpacity={0.42} />
      </linearGradient>
      <linearGradient
        id="dot-net_svgd"
        x1={443.12}
        x2={443.12}
        y1={-316.23}
        y2={2105.42}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#166AB8" />
        <stop offset={0.4} stopColor="#36AEE8" />
        <stop offset={0.85} stopColor="#0798DD" />
        <stop offset={1} stopColor="#0798DD" />
      </linearGradient>
      <linearGradient
        id="dot-net_svge"
        x1={565}
        x2={565}
        y1={-336.08}
        y2={2239.03}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#124379" />
        <stop offset={0.39} stopColor="#1487CB" />
        <stop offset={0.78} stopColor="#165197" />
        <stop offset={1} stopColor="#165197" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgf"
        x1={13.11}
        x2={377.19}
        y1={292.5}
        y2={292.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#33BDF2" stopOpacity={0.7} />
        <stop offset={1} stopColor="#1DACD8" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgg"
        x1={775.13}
        x2={775.13}
        y1={1752.04}
        y2={-55.84}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#136AB4" />
        <stop offset={0.6} stopColor="#59CAF5" stopOpacity={0.55} />
        <stop offset={1} stopColor="#59CAF5" stopOpacity={0.24} />
      </linearGradient>
      <linearGradient
        id="dot-net_svgh"
        x1={0.18}
        x2={1350.6}
        y1={930.15}
        y2={930.15}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#05A1E6" stopOpacity={0.25} />
        <stop offset={1} stopColor="#05A1E6" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgi"
        x1={462.9}
        x2={462.9}
        y1={1721.6}
        y2={-129.51}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#318ED5" />
        <stop offset={1} stopColor="#38A7E4" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgj"
        x1={432.08}
        x2={432.08}
        y1={985.29}
        y2={-814.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#05A1E6" />
        <stop offset={1} stopColor="#05A1E6" stopOpacity={0.55} />
      </linearGradient>
      <linearGradient
        id="dot-net_svgk"
        x1={497.24}
        x2={497.24}
        y1={1524.54}
        y2={4.03}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1959A6" />
        <stop offset={0.5} stopColor="#05A1E6" />
        <stop offset={0.92} stopColor="#7EC5EA" />
        <stop offset={1} stopColor="#7EC5EA" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgl"
        x1={817.17}
        x2={301.76}
        y1={1756.05}
        y2={180.92}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#165096" />
        <stop offset={1} stopColor="#0D82CA" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgm"
        x1={341.43}
        x2={341.43}
        y1={826.71}
        y2={-34.87}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#05A1E6" />
        <stop offset={0.87} stopColor="#0495D6" />
        <stop offset={1} stopColor="#0495D6" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgn"
        x1={771.53}
        x2={-31.46}
        y1={-75.03}
        y2={1707.84}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#38A7E4" stopOpacity={0.33} />
        <stop offset={0.96} stopColor="#0E88D3" />
        <stop offset={1} stopColor="#0E88D3" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgo"
        x1={690.79}
        x2={690.79}
        y1={-5.31}
        y2={1874.32}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#168CD4" />
        <stop offset={0.5} stopColor="#1C87CC" />
        <stop offset={1} stopColor="#154B8D" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgp"
        x1={114.76}
        x2={122.9}
        y1={-162.45}
        y2={34.68}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#97D6EE" />
        <stop offset={0.7} stopColor="#55C1EA" />
        <stop offset={1} stopColor="#55C1EA" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgq"
        x1={50.65}
        x2={87.47}
        y1={-6.91}
        y2={-215.73}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7ACCEC" />
        <stop offset={1} stopColor="#3FB7ED" />
      </linearGradient>
      <linearGradient
        id="dot-net_svgr"
        x1={518.73}
        x2={518.73}
        y1={96.35}
        y2={1934.82}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1DA7E7" />
        <stop offset={1} stopColor="#37ABE7" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>,
  "DotNet",
);
export default DotNetIcon;
